import React from "react";
import FormInfo from "./FormInfo";
import TextInput from "./element/TextInput";
import AddButton from "./element/AddButton";
import DeleteButton from "./element/DeleteButton";
function FormInfos({ id, info, updateData, addData, removeData }) {
  function handleTitleChange(e) {
    updateData({
      mainId: id,
      newValue: e.target.value,
      category: "leftColumnTitle",
    });
  }
  function handleAdd() {
    addData({ category: "info", mainId: id });
  }

  function handleDelete() {
    removeData({ category: "formInfo", mainId: id });
  }

  return (
    <>
      <div className="my-4">
        <div className="flex items-center pb-2 gap-4">
          <p className="text-base font-semibold">Form Info</p>{" "}
          <DeleteButton handleDelete={handleDelete} />
        </div>
        <div className="">
          <div className="pb-2">
            <TextInput
              labelText="Title:"
              inputName="name"
              inputOnChange={handleTitleChange}
              inputValue={info.name}
            />
          </div>
          {info.items.map((item, index) => {
            return (
              <FormInfo
                key={item.id}
                itemId={index}
                item={item}
                updateData={updateData}
                infoId={id}
                removeData={removeData}
              />
            );
          })}
          <AddButton handleAdd={handleAdd} text={"+ info item"} />
        </div>
      </div>
    </>
  );
}

export default FormInfos;
